import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  withState,
  lifecycle,
  withHandlers,
  getContext,
} from 'recompose';
import { forms, apiHOCs } from 'components';
import moment from 'moment';

import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';

const TopicsScreen = ({
  modal,
  setModal,
  initTopic,
  setInitTopic,
  selected,
  setSelected,
  showMore,
  putTopic,
  topics,
  deleteTopic,
  topicsMeta,
  postCreateTopic,
  match,
  router,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Paper
      elevation={1}
      style={{
        width: 800,
        padding: 10,
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      <Typography
        variant="headline"
        component="h3"
        style={{
          textAlign: 'center',
        }}
      >
        Topics
      </Typography>
    </Paper>
    <Paper
      elevation={1}
      style={{
        width: 820,
        padding: 10,
      }}
    >
      <List>
        {
          topics.map(topic => (
            <ListItem
              key={topic.get('id')}
              button
              onClick={() => router.history.push(`/forum/posts/${topic.get('id')}`)}
            >
              <ListItemText
                primary={`Title: ${topic.get('title')} Id: ${topic.get('id')}`}
                secondary={moment(topic.get('createdAt')).format('MMMM Do YYYY, HH:mm:ss')}
              />
              <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  putTopic({
                    requestBody: {
                      id: topic.get('id'),
                      isFixed: JSON.stringify(!topic.get('isFixed')),
                    },
                  });
                }}
                style={{ marginRight: 15 }}
                color="primary"
              >
                {topic.get('isFixed') ? 'UNFIX' : 'FIX'}
              </Button>
              <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  putTopic({
                    requestBody: {
                      id: topic.get('id'),
                      isClosed: JSON.stringify(!topic.get('isClosed')),
                    },
                  });
                }}
                style={{ marginRight: 15 }}
                color="secondary"
              >
                {topic.get('isClosed') ? 'OPEN' : 'CLOSE'}
              </Button>
              <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  setInitTopic({
                    title: topic.get('title'),
                  });
                  setSelected(topic.get('id'));
                  setModal(true);
                }}
                style={{ marginRight: 15 }}
                color="primary"
              >
                EDIT
              </Button>
              <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  setInitTopic({});
                  deleteTopic(topic.get('id'));
                }}
                color="secondary"
              >
                DELETE
              </Button>
            </ListItem>
          ))
        }
      </List>
      {
        topicsMeta && topicsMeta.get('total') > 1 && (
          <Button
            variant="contained"
            onClick={showMore}
            color="primary"
            style={{ marginBottom: 30 }}
            fullWidth
          >
            SHOW MORE
          </Button>
        )
      }
      <Button
        variant="contained"
        onClick={() => setModal(true)}
        color="primary"
        fullWidth
      >
        ADD NEW
      </Button>
    </Paper>
    <Modal
      open={modal}
      onClose={() => {
        setModal(false);
        setInitTopic({});
        setSelected('');
      }}
    >
      <Paper
        elevation={1}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: 1000,
          height: 700,
          overflow: 'auto',
          padding: 20,
        }}
      >
        {
          modal && <forms.TopicsForm
            onSubmit={body =>
              selected === ''
                ? postCreateTopic({
                  requestBody: {
                    boardId: match.params.id,
                    title: body.get('title'),
                    msg: {
                      body: body.get('body'),
                      attachments: body.get('images'),
                    },
                    isSubNow: false,
                  },
                }).then((resp) => {
                  if (!resp.body.error) {
                    setModal(false);
                  } else {
                    alert('postCreateTopic error');
                    console.log(JSON.stringify(resp.body.data));
                  }
                })
                : putTopic({
                  requestBody: {
                    id: selected,
                    title: body.get('title'),
                  },
                }).then((resp) => {
                  if (!resp.body.error) {
                    setModal(false);
                  } else {
                    alert('putTopic error');
                    console.log(JSON.stringify(resp.body.data));
                  }
                })
            }
            type={selected === '' ? 'create' : 'save'}
            initialValues={initTopic}
          />
        }
      </Paper>
    </Modal>
  </div>
);

TopicsScreen.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  initTopic: PropTypes.object.isRequired,
  setInitTopic: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  setSelected: PropTypes.func.isRequired,
  showMore: PropTypes.func.isRequired,
  putTopic: PropTypes.func.isRequired,
  topics: PropTypes.object.isRequired,
  deleteTopic: PropTypes.func.isRequired,
  topicsMeta: PropTypes.object.isRequired,
  postCreateTopic: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default compose(
  apiHOCs.TopicsApiHOC(),
  withState('modal', 'setModal', false),
  withState('initTopic', 'setInitTopic', { newsId: '', images: [] }),
  withState('selected', 'setSelected', ''),

  getContext({
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }),

  withHandlers({
    showMore: ({ topicsMeta, getTopics, match }) => () => {
      getTopics(
        match.params.id,
        {
          page: 1,
          count: topicsMeta.get('limit') + 20,
      }).then((resp) => {
        if (resp.body.error) {
          alert('getTopics error');
          console.log(JSON.stringify(resp.body.data));
        }
      });
    },
  }),

  lifecycle({
    componentDidMount() {
      this.props.getTopics(this.props.match.params.id);
    },
  }),
)(TopicsScreen);
